import React from 'react';
import type User from '@this/domain/user/user';
import type Calendar from '@this/domain/appoint/calendar';
import type { SnackbarContent } from './common';

interface Context {
  user: User | null;
  calendars: Calendar[];
  setCalendars: (calendars: Calendar[]) => void;
  setOpenSnackbar: (open: boolean) => void;
  setSnackbarContent: (content: SnackbarContent) => void;
  onUserSignedIn: () => void;
  onUserSignedOut: () => void;
  googleOauthPath: string;
  outlookOauthPath: string;
  env: string;
  isMobile: boolean;
  fixWithCalendar: boolean | null; // nullでない時だけHeaderに切り替えボタンを表示する
}

const AppointContext = React.createContext<Context>({
  user: null,
  calendars: [],
  setCalendars: () => {},
  setOpenSnackbar: (open: boolean) => {},
  setSnackbarContent: (content: SnackbarContent) => {},
  onUserSignedIn: () => {},
  onUserSignedOut: () => {},
  googleOauthPath: '',
  outlookOauthPath: '',
  env: '',
  isMobile: false,
  fixWithCalendar: true
});
export default AppointContext;
